import * as ko from "knockout";
import {Tab} from "../../tab-list/Tab";
import {IMessageData, IRouteDefinitionParams, TRouteId} from "../../../index";
import {nsRoute} from "../../../util/route";
import {createErrorMessage} from "../../../util/misc";
import {nsBadge} from "../../../util/badge";
import pubsub from "../../../pubsub";
import {getObjectFromRouteData} from "../../../util/request";
import {TServiceName} from "../../../constants/ApiServices";
import {global} from "../../../appContext";
import PromiseRequest from "../../../req/PromiseRequest";
import {REQUEST_MESSAGE} from "../../../constants/Language";
import ParsedRouteDataDecorator = nsRoute.ParsedRouteDataDecorator;
import TBadgeValue = nsBadge.TBadgeValue;
import TBadgeObject = nsBadge.TBadgeObject;
import AbstractHtml from './Abstract.html?raw';

export const tpl = AbstractHtml;

export abstract class Abstract extends ParsedRouteDataDecorator {

    protected tabs: Tab[] = [];
    protected readonly isReady: KnockoutObservable<boolean | null> = ko.observable(null);
    protected readonly messageData: KnockoutObservable<IMessageData | null> = ko.observable(null);
    protected data: any = null;
    protected requests: PromiseRequest[] = [];

    constructor(params: IRouteDefinitionParams) {
        super(params);
        this.tabs = this.__tabManager?.tabs() ?? [];
        pubsub.on(this, 'object.needs.refresh', () => {
            this.init();
        });
    }

    protected init(): Promise<any> {
        this.isReady(false);
        this.messageData({message: REQUEST_MESSAGE});
        if (!this.__requestRouteData) {
            return Promise.resolve();
        }
        return this.__requestRouteData
            .request()
            .then(this.onSuccess.bind(this))
            .catch(this.onError.bind(this));
    }

    protected onSuccess(data: any[]): Promise<any> {
        this.initData(data);
        this.setupButtons();
        this.messageData(null);
        this.isReady(true);
        return Promise.resolve(data);
    }

    protected onError(reason: string) {
        this.messageData(createErrorMessage(String(reason)));
    }

    protected initData(data: any[] | null = null) {
        if (!this.__routeDef) {
            return;
        }
        this.data = getObjectFromRouteData(data, this.__routeDef, this.__routeParams);
        const routeIds = this.__tabManager?.getAllTabs().map(t => t.id) ?? [];
        routeIds.forEach(id => {
            try {
                let val = this.getBadgeValue(id, this.data);
                const tab = this.__tabManager?.getTab(id);
                const badge = tab?.badge;
                if (!badge) {
                    return;
                }
                switch (typeof val) {
                    case "number":
                    case "string":
                        badge(val);
                        break;
                    default:
                        badge(val)
                        break;
                }
            } catch (err) {
            }
        });
    }

    protected setupButtons() {
        // override this
    }

    protected getBadgeValue(_id: TRouteId, _obj: any): TBadgeValue | TBadgeObject | null {
        // override this
        return null;
    }

    protected getPromiseRequest(serviceName: TServiceName) {
        const ret = global.getPromiseRequest(serviceName);
        this.requests.push(ret);
        return ret;
    }

    override dispose() {
        super.dispose();
        this.requests.forEach(p => p.abort());
    }
}
